const VendorsModule = () => import('@pages/vendors/VendorsModule')
const VendorsIndex = () => import('@pages/vendors/VendorsIndex')
const VendorContacts = () => import('@pages/vendors/VendorsContactsIndex')

export default {
    path: 'vendors',
    component: VendorsModule,
    children: [
        {
            path: 'vendors-index',
            component: VendorsIndex,
            name: 'vendorsPage',
        },
        {
            path: 'vendor-contacts',
            component: VendorContacts,
            name: 'vendor-contacts',
            props: true,
        },
    ],
}
